import { render, staticRenderFns } from "./FailedVerification.vue?vue&type=template&id=025dd28e&"
import script from "./FailedVerification.vue?vue&type=script&lang=js&"
export * from "./FailedVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports